import { ModalDrawer } from '@egw/components'
import { type EnrollmentEquitySectorRecommendationOutput } from '@egw/api/src/models/enrollment/enrollment'
import { type Dispatch, type SetStateAction, type ChangeEvent, type FC } from 'react'
import { Equity } from '../equity/equity'
import { ExperienceName } from '../../constants/api/experience-name'
import { type RiskTolerance } from '../modal-risk-tolerance/modal-risk-tolerance'

interface EquityProps {
  isOpen: boolean
  onClose: () => void
  riskTolerance?: RiskTolerance
  initEquityData: EnrollmentEquitySectorRecommendationOutput[] | undefined
  sliderData?: EnrollmentEquitySectorRecommendationOutput[] | undefined
  handleContinueClick: () => void
  setEquityData?: Dispatch<SetStateAction<EnrollmentEquitySectorRecommendationOutput[] | undefined>>
  withContainer?: boolean
  isShowCurrentValue?: boolean
  experience?: string
}

export const ModalEquity: FC<EquityProps> = ({
  isOpen,
  onClose,
  riskTolerance,
  sliderData,
  setEquityData,
  handleContinueClick,
  initEquityData,
  experience = ExperienceName.BBQ,
}) => {
  const onChangeSliders = (index: number, event: ChangeEvent<HTMLInputElement>): void => {
    const newValue = Number(event.target.value)

    setEquityData?.((prevState) =>
      prevState?.map((slider, i) =>
        i === index
          ? {
              ...slider,
              currentAllocationPercent: newValue,
              recommendedRange: {
                ...slider.recommendedRange,
              },
            }
          : slider,
      ),
    )
  }

  const handleCloseModal = (): void => {
    setEquityData?.(initEquityData)
    onClose()
  }

  return (
    <ModalDrawer isOpen={isOpen} title="" onClose={handleCloseModal} testId="equity-modal">
      <Equity
        riskTolerance={riskTolerance}
        sliderData={sliderData}
        onChangeSliders={onChangeSliders}
        withContainer={false}
        isShowCurrentValue
        handleContinueClick={() => {
          handleContinueClick()
        }}
        experience={experience}
      />
    </ModalDrawer>
  )
}
